import { Close } from "@mui/icons-material";
import { Box, FormControl, FormHelperText, IconButton } from "@mui/material";
import { useTranslation } from "react-i18next";

import DateField from "../../../components/editable/EditableField/fields/DateField";
import { usePreferences } from "../../../utility/usePreferences";
import { getTomorrowAtLocalMidnightUtc, isFutureLocalDate, toLocalMidnightUtc } from "../utils/availabilityDate";

interface AvailabilityDateFieldProps {
  disabled?: boolean;
  inputIsValid: boolean;
  label: string;
  testId: string;
  value: Date | null | undefined;
  onChange: (value: Date | null) => void;
  onInputValidityChange: (isValid: boolean) => void;
}

const AvailabilityDateField = ({
  disabled = false,
  inputIsValid,
  label,
  testId,
  value,
  onChange,
  onInputValidityChange,
}: AvailabilityDateFieldProps) => {
  const { t } = useTranslation();
  const { timeZone } = usePreferences();
  const localMidnight = value ? toLocalMidnightUtc(value, timeZone) : null;
  const isValid = inputIsValid && isFutureLocalDate(value, timeZone);
  const clear = () => {
    onInputValidityChange(true);
    onChange(null);
  };

  return (
    <fieldset disabled={disabled} style={{ border: 0, margin: 0, padding: 0, minWidth: 0 }}>
      <FormControl error={!isValid} fullWidth>
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, maxWidth: 280, px: 1.25 }}>
          <Box sx={{ width: 225, flexShrink: 0 }}>
            <DateField
              label={label}
              testId={testId}
              minDate={getTomorrowAtLocalMidnightUtc(timeZone)}
              value={localMidnight?.toISOString() ?? null}
              onValidityChange={onInputValidityChange}
              onClear={clear}
              onChange={(date) => onChange(toLocalMidnightUtc(new Date(date), timeZone))}
            />
          </Box>
          <Box sx={{ width: 30, flexShrink: 0 }}>
            {value ? (
              <IconButton aria-label={t("general.clear")} size="small" onClick={clear}>
                <Close fontSize="small" />
              </IconButton>
            ) : null}
          </Box>
        </Box>
        {!isValid ? <FormHelperText>{t("input.errors.dateMustBeAfterToday")}</FormHelperText> : null}
      </FormControl>
    </fieldset>
  );
};

export default AvailabilityDateField;
